<template>
  <div class="emergency-base">
    <Card>
      <Card :dis-hover="true" :bordered="false" :padding="10" style="text-align: right">
        <!--      <Button type="primary" size="small" style="margin-left: 8px">重置</Button>-->
        <Button disabled type="primary" @click="gotoAdd" style="margin-left: 4px">新增
        </Button>
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">导入</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">导出</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">模版下载</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">批量删除</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">批量维护</Button>-->
      </Card>
      <Card :dis-hover="true" :bordered="false" :padding="0">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="类型" :label-style="{'text-align': 'right', 'width':'120px'}">
            <RadioGroup size="small" v-model="baseType" type="button" @on-change="tagChange">
              <Radio :label="0">全部</Radio>
              <Radio :label="1">物资库</Radio>
              <Radio :label="2">机械设备库</Radio>
              <Radio :label="3">综合库</Radio>
            </RadioGroup>
          </el-descriptions-item>
          <el-descriptions-item label="行政区划" :label-style="{'text-align': 'right'}">
            <Row>
              <Col :span="6">
                <span>区县：</span>
                <Select transfer v-model="country" :disabled="countryList.length === 1" clearable style="width:200px">
                  <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
                </Select>
              </Col>
              <Col :span="7">
                <span>仓库名称：</span>
                <Input clearable v-model="baseName" style="width:200px"></Input>
              </Col>
              <Col :span="6">
                <Button type="primary" @click="getEmergencyBase">查询</Button>
              </Col>
            </Row>
          </el-descriptions-item>
        </el-descriptions>
        <!--      <div style="text-align: center;margin-top: 10px">-->
        <!--        <Button type="primary" size="small">查询</Button>-->
        <!--        <Button type="primary" size="small" style="margin-left: 8px">重置</Button>-->
        <!--      </div>-->
      </Card>
      <Row :gutter="4" style="margin-top: 10px">
        <Col :span="showMap ? 15 : 24">
          <Card :dis-hover="true" :padding="4" :bordered="false">
            <div @click="mapShow" v-if="!showMap"
                 style="background-color: #515a6e;position: absolute;top: 4px;right: 0;z-index: 999">
              <Icon type="ios-arrow-back" size="36" color="#fff"/>
            </div>
            <Table
                :loading="dataLoading"
                :columns="columns"
                :data="data"
                :border="false"
                :stripe="false"
                :highlight-current-row="true"
            >
              <template #action="{ row, index }">
                <el-button size="small" type="text" @click="makeLocation(row)">定位</el-button>
                <!--              <el-button size="small" type="text" @click="gotoDetail(row)">查看</el-button>-->
                <el-button disabled size="small" type="text"
                           @click="editBase(row)">编辑
                </el-button>
                <el-button disabled size="small" type="text"
                           @click="deleteBase(row)">删除
                </el-button>
                <el-button size="small" type="text" @click="resourceDetail(row)">物资管理</el-button>
              </template>
            </Table>
            <Page style="text-align: right;margin-top: 10px"
                  show-sizer
                  show-total
                  transfer
                  :total="dataTotal"
                  :page-size="pageSize"
                  :page-size-opts="pageSizeOpts"
                  :current-page="currentPage"
                  @on-change="pageChange"
                  @on-page-size-change="pageSizeChange"
            ></Page>
          </Card>
        </Col>
        <Col :span="showMap ? 9 : 0">
          <Card :dis-hover="true" v-if="showMap" :padding="0" style="position: relative">
            <div @click="mapShow" style="background-color: #515a6e;position: absolute;top: 4px;z-index: 999">
              <Icon type="ios-arrow-forward" size="36" color="#fff"/>
            </div>
            <div id="map" style="width: 100%;height: 600px;"></div>
          </Card>
        </Col>
      </Row>
    </Card>

    <Drawer title="物资管理" width="740" :mask-closable="false" closable v-model="resDetail">
      <Button disabled @click="addResPage" type="primary">新增</Button>
      <emergency-resource :data="resourceList" :res-loading="resLoading"
                          @deleteResource="deleteResource"></emergency-resource>
    </Drawer>
    <Modal title="新增" width="512" :mask-closable="false" v-model="addRes" :footer-hide="true" :styles="{top: '0px'}">
      <add-em-resource @closeModal="modalClose" :belongStore="selectBaseId" :status="'add'"></add-em-resource>
    </Modal>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'
import EmergencyResource from '@/views/Resources/emergencyResource/emergencyResource.vue'
import AddEmResource from '@/views/Resources/emergencyResource/addEmResource/addEmResource.vue'

export default {
  name: "emergencyBase",
  components: { AddEmResource, EmergencyResource },
  data() {
    return {
      showMap: false,
      resDetail: false,
      addRes: false,
      selectBaseId: 0,
      resourceList: [],
      baseType: 0,
      baseName: '',
      country: '',
      countryList: [],
      dataLoading: false,
      resLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '所属区县',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `${params.row.areaName}`)
          }
        },
        {
          title: '仓库名称',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.storeHouse.name)
          }
        },
        {
          title: '详细地址',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.storeHouse.address)
          }
        },
        {
          title: '负责人',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.storeHouse.personInCharge)
          }
        },
        {
          title: '负责人手机',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.storeHouse.personInChargePhone)
          }
        },
        {
          width: '180',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action'
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUserId: '',
      map: null
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          // console.log(newVal)
          this.curUserId = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        // console.log(this.$store)
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    // this.initBMap()
    this.getEmergencyBase()
    this.getCountry()
  },
  methods: {
    initBMap(lng, lat) {
      // this.map = new BMapGL.Map("map");          // 创建地图实例
      // let point = new BMapGL.Point(lng, lat);  // 创建点坐标
      // this.map.centerAndZoom(point, 15);
      // this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        // const point = new BMap.Point(116.36555, 37.44131)
        map.centerAndZoom('德州市', 12)
        // var marker = new BMap.Marker(point)
        // this.map.addOverlay(marker);
        // var lat = Number(row.emergencyTeam.longitude) // 经度
        // var lng = Number(row.emergencyTeam.dimension) // 纬度
        // var point = new this.BMap.Point(lng, lat)
        // var marker = new this.BMap.Marker(point)
        // map.addOverlay(marker);
        // map.centerAndZoom(point, 16)
      })
    },
    makeLocation(row) {
      this.showMap = true
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        this.map.centerAndZoom('德州市', 12)
      })
      if (row.storeHouse.longitude === null && row.storeHouse.dimension === null) {
        // this.$Message.error("该队伍未设置坐标")
        return;
      }
      let lat = Number(row.storeHouse.longitude) // 经度
      let lng = Number(row.storeHouse.dimension) // 纬度
      var point = new this.BMap.Point(lng, lat)
      var marker = new this.BMap.Marker(point)
      this.map.addOverlay(marker);
      this.map.centerAndZoom(point, 16)
    },
    mapShow() {
      this.showMap = !this.showMap
      this.initBMap()
      // if (this.showMap) {
      //   this.initBMap()
      // }
    },
    gotoAdd() {
      this.$router.push({
        name: 'addEmBase'
      })
    },
    editBase(row) {
      this.$router.push({
        name: 'addEmBase',
        params: {
          row: row
        }
      })
    },
    gotoDetail(row) {
      this.$router.push({
        name: 'emBaseDetail',
        params: {
          row: row
        }
      })
    },
    deleteBase(row) {
      this.$http.get(`/api/storehouse/delete/${row.storeHouse.id}`).then(res => {
        // console.log(res)
        this.getEmergencyBase()
      })
    },
    resourceDetail(row) {
      this.resDetail = true
      this.selectBaseId = Number(row.storeHouse.id)
      this.getEmergencyResource(this.selectBaseId)
    },
    addResPage() {
      this.addRes = true
    },
    modalClose(data) {
      this.addRes = false
      this.getEmergencyResource(this.selectBaseId)
    },
    deleteResource(data) {
      this.$http.get(`/api/goods/delete/${data.id}`).then(res => {
        // console.log(res)
        this.getEmergencyResource(this.selectBaseId)
      })
    },
    getEmergencyResource(storeId) {
      this.resLoading = true
      this.$http.get(`/api/goods/getGoods/${storeId}`).then(res => {
        // console.log(res)
        this.resourceList = res.data.data
        // this.data = res.data.data.list
        // this.dataTotal = res.data.data.total
        this.resLoading = false
      })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=4').then(res => {
        // console.log(res)
        this.countryList = res.data
        if (this.countryList.length === 1) {
          this.country = res.data[0].indexCode
        }
      })
    },
    //根据区县获取街道
    getStreet() {
      this.$http.get(`/api/street/${1}`).then(res => {
        // console.log(res)
      })
    },
    getEmergencyBase() {
      this.dataLoading = true
      let params = {
        storeHouseType: this.baseType === 0 ? '' : this.baseType,
        name: this.baseName,
        responsibleAreaId: this.country
      }
      this.$http.post(`/api/storehouse/getAll?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        // console.log(res)
        this.data = res.data.data.list
        this.dataTotal = res.data.data.total
        this.dataLoading = false
      })
    },
    tagChange(value) {
      // console.log(value)
      this.getEmergencyBase()
    },
    pageChange(page) {
      this.currentPage = page
      this.getEmergencyBase()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getEmergencyBase()
    }
  }
}
</script>

<style scoped lang="less">
.emergency-base {
  .ivu-radio-group-item {
    margin-left: 16px;
  }
}
</style>
